import { render, staticRenderFns } from "./VRichTextRenderer.vue?vue&type=template&id=29033bd0"
import script from "./VRichTextRenderer.vue?vue&type=script&lang=js"
export * from "./VRichTextRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports